import {
  FLOOR_PLAN_GRID_SIZES,
  formatLength,
  type FloorPlanGridSize,
  type LengthUnits,
} from '@peles/shared';
import { ToolbarToggleGroup } from './ToolbarToggleGroup';

interface GridSizeControlProps {
  size: FloorPlanGridSize;
  units: LengthUnits;
  onChange: (size: FloorPlanGridSize) => void;
  disabled?: boolean;
}

/**
 * The plan's grid: how far apart its lines are drawn and what a drag snaps
 * to. Each plan keeps its own — 6 inches for lining up chairs, 5 feet for
 * blocking out a hall. Sizes read in the plan's chosen units.
 */
export function GridSizeControl({ size, units, onChange, disabled }: GridSizeControlProps) {
  return (
    <ToolbarToggleGroup
      ariaLabel="Grid size"
      data-testid="grid-size-control"
      value={size}
      onChange={onChange}
      disabled={disabled}
      options={FLOOR_PLAN_GRID_SIZES.map((option) => {
        const label = formatLength(option, units);
        return {
          value: option,
          label,
          ariaLabel: `${label} grid`,
          title: `Draw and snap to a ${label} grid`,
          testId: `grid-size-${option}`,
        };
      })}
    />
  );
}
